module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.active_pay || (_vm.project && _vm.project.unlocked)) ? _c('md-list-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.ensureLoaded.apply(null, arguments)
      }
    }
  }, [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators")]), _vm._v(" "), _c('md-list-expand', {
    staticClass: "ql-invite-form"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.inviting),
      expression: "!inviting"
    }],
    attrs: {
      "nvalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.inviteNew.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.showError
    }
  }, [_c('label', {
    attrs: {
      "for": "invite-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "invite-email",
      "type": "email",
      "required": "",
      "role": "combobox",
      "aria-autocomplete": "list",
      "aria-controls": "invite-suggestions",
      "aria-expanded": _vm.showSuggestions ? 'true' : 'false',
      "aria-activedescendant": _vm.activeDescendantId
    },
    nativeOn: {
      "focusin": function($event) {
        return _vm.onFieldFocus.apply(null, arguments)
      },
      "focusout": function($event) {
        return _vm.onFieldBlur.apply(null, arguments)
      },
      "keydown": function($event) {
        return _vm.onKeydown.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.newInvitee.email),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "email", $$v)
      },
      expression: "newInvitee.email"
    }
  }), _vm._v(" "), (_vm.showError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ql-invite-suggest"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuggestions && (_vm.loading || _vm.filteredSuggestions.length)),
      expression: "showSuggestions && (loading || filteredSuggestions.length)"
    }],
    staticClass: "ql-invite-suggestions",
    attrs: {
      "id": "invite-suggestions",
      "role": "listbox"
    }
  }, [(!_vm.loading && _vm.filteredSuggestions.length) ? _c('li', {
    staticClass: "ql-suggest-caption",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("People you've worked with")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('li', {
    staticClass: "ql-suggest-loading",
    attrs: {
      "aria-disabled": "true"
    }
  }, [_vm._v("Finding people you've worked with…")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSuggestions), function(s, i) {
    return _c('li', {
      key: s.uid || s.email,
      class: ['ql-suggest-item', {
        'is-active': i === _vm.activeIndex
      }],
      attrs: {
        "id": 'invite-suggestion-' + i,
        "role": "option",
        "aria-selected": i === _vm.activeIndex ? 'true' : 'false'
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.selectSuggestion(s)
        },
        "mousemove": function($event) {
          _vm.activeIndex = i
        }
      }
    }, [_c('span', {
      staticClass: "ql-suggest-name"
    }, [_vm._v(_vm._s(s.name || s.email))]), _vm._v(" "), (s.email) ? _c('span', {
      staticClass: "ql-suggest-email",
      attrs: {
        "title": s.email
      }
    }, [_vm._v(_vm._s(s.email))]) : _vm._e(), _vm._v(" "), (s.source === 'inviter') ? _c('span', {
      staticClass: "ql-suggest-src"
    }, [_vm._v("Invited you before")]) : (s.source === 'affiliate') ? _c('span', {
      staticClass: "ql-suggest-src"
    }, [_vm._v("Affiliate")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuggestions && _vm.loaded && !_vm.loading && !_vm.filteredSuggestions.length && _vm.hasQuery),
      expression: "showSuggestions && loaded && !loading && !filteredSuggestions.length && hasQuery"
    }],
    staticClass: "ql-suggest-empty"
  }, [_vm._v("No previous contacts match")])]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "invite-name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "invite-name",
      "type": "text",
      "required": ""
    },
    nativeOn: {
      "focusin": function($event) {
        return _vm.onFieldFocus.apply(null, arguments)
      },
      "focusout": function($event) {
        return _vm.onFieldBlur.apply(null, arguments)
      },
      "keydown": function($event) {
        return _vm.onKeydown.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.newInvitee.name),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "name", $$v)
      },
      expression: "newInvitee.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "invite-role"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "invite-role",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.newInvitee.role),
      callback: function($$v) {
        _vm.$set(_vm.newInvitee, "role", $$v)
      },
      expression: "newInvitee.role"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "type": "submit",
      "disabled": _vm.checking
    }
  }, [_c('md-icon', [_vm._v("person_add")]), _vm._v(" " + _vm._s(_vm.checking ? 'Sending…' : 'Send Invite'))], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.resetInvitee
    }
  }, [_vm._v("Clear")])], 1), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && !_vm.emailSent),
      expression: "inviting && !emailSent"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inviting && _vm.emailSent),
      expression: "inviting && emailSent"
    }],
    attrs: {
      "id": "done-icon"
    }
  }, [_vm._v("done")])], 1)], 1)], 1) : _c('md-list-item', [_c('md-subheader', {
    staticClass: "ql-invite-header"
  }, [_vm._v("Invite Collaborators (disabled)")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0cd5cf0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/invite.vue
// module id = 1289
// module chunks = 21